import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-3, message, chat"><path d="M12 2C6.47715 2 2 6.47715 2 12C2 13.4157 2.29465 14.7646 2.82668 15.9871C2.92281 16.208 2.93578 16.4267 2.88015 16.6069L2.10456 19.119C1.57614 20.8305 3.16229 22.4432 4.88237 21.9433L7.53617 21.172C7.70954 21.1217 7.91818 21.1344 8.13052 21.2236C9.32175 21.7239 10.6296 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubble3;
